const Tooltip = {
    bind (el, binding) {
        let tooltip = new bootstrap.Tooltip(el, {
            title: binding.value,
            placement: binding.arg,
            container: 'body',
            trigger: 'hover'
        });
        /**
         * Fix Bootstrap's (or Popper.js) bug with undissapearing tooltips after mouse leave the element
         * */
        el.addEventListener('mouseleave', function() {
            tooltip.hide();
        })
    }
}

export default Tooltip;
